import {
  theme,
  Button,
  Card,
  Box,
  Separator,
} from '@fe-toolkit/web-components/ssr'
import { Fragment } from 'react'

type LinkListCardItemProps = {
  text: string
  onClick: () => void
  isFirstItem: boolean
  isLastItem: boolean
}

const LinkListCardItem = ({
  text,
  onClick,
  isFirstItem,
  isLastItem,
}: LinkListCardItemProps) => {
  return (
    <Button
      isFullWidth
      sx={{
        padding: theme.spacing.small,
        textAlign: 'left',
        fontWeight: theme.fontWeights.speak,
        fontSize: theme.fontSizes.speak,
        color: theme.colors.black,
        '&:hover': {
          backgroundColor: theme.colors.wildSand,
        },
        borderTopLeftRadius: isFirstItem ? theme.borderRadius.small : 0,
        borderTopRightRadius: isFirstItem ? theme.borderRadius.small : 0,
        borderBottomLeftRadius: isLastItem ? theme.borderRadius.small : 0,
        borderBottomRightRadius: isLastItem ? theme.borderRadius.small : 0,
      }}
      variant="link"
      onClick={onClick}
    >
      {text}
    </Button>
  )
}

type LinkListCardProps = {
  items: { key: string; text: string; onClick: () => void }[]
  ariaLabel?: string
}

const LinkListCard = ({ items, ariaLabel }: LinkListCardProps) => {
  return (
    <Card
      ariaLabel={ariaLabel}
      backgroundColor="white"
      borderRadius="small"
      sx={{
        '&:focus-visible, &:focus, &:hover': {
          outline: `solid 2px ${theme.colors.lightBlue}`,
        },
      }}
    >
      {items.map((item, index) => {
        const isFirstItem = index === 0
        const isLastItem = index === items.length - 1
        return (
          <Fragment key={item.key}>
            <LinkListCardItem
              isFirstItem={isFirstItem}
              isLastItem={isLastItem}
              text={item.text}
              onClick={item.onClick}
            />
            {!isLastItem && (
              <Box px={theme.spacing.small}>
                <Separator colour="gallery" />
              </Box>
            )}
          </Fragment>
        )
      })}
    </Card>
  )
}

export default LinkListCard
